// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"541":"de66022c","703":"038a24c2"}[chunkId] + ".chunk.js";
};